import React from 'react';
import { Layout, theme } from 'antd';
import awardsLogo from "../../assets/images/ACE Logo.png";
import arrows from "../../assets/app/Small Multiple Arrows.png";

const { Header } = Layout;
interface AppHeaderProps {
    subtitle: string;
}


const AppHeaderTemplate2: React.FC<AppHeaderProps> = ({ subtitle }) => {
    const {
        token: { colorBgContainer },
    } = theme.useToken();

    return (
        <Header
            style={{
                background: colorBgContainer,
                minHeight: '90px',
                borderBottom: '5px solid purple',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: '0px',
                flexWrap: 'nowrap',
                marginTop: 0,
                paddingTop: 0,
            }}
            className="app-header-responsive"
        >
            <img
                src={awardsLogo}
                alt="ACE Logo"
                className="header-logo"
                style={{
                    width: '60px',
                    height: '60px',
                    objectFit: 'contain',
                    flexShrink: 0,
                    display: 'block',
                }}
            />
            <div
                style={{
                    flex: 1,
                    minWidth: 0,
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center',
                    gap: '0px',
                    flexWrap: 'wrap',
                }}
            >
                <h1
                    style={{
                        color: 'black',
                        fontSize: '20px',
                        margin: 0,
                        wordBreak: 'break-word',
                        fontWeight: 600,
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        maxWidth: '100%',
                    }}
                >
                    Aptean's Global Reward & Recognition | H2 2025
                </h1>
                <span className="header-separator" style={{ margin: '0 8px', color: '#999', fontSize: 18 }}>|</span>
                <h2 className="header-subtitle"
                    style={{
                        color: 'black',
                        fontSize: '16px',
                        margin: 0,
                        wordBreak: 'break-word',
                        fontWeight: 400,
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        maxWidth: '100%',
                    }}
                >
                    {subtitle}
                </h2>
            </div>
            <img
                src={arrows}
                alt="Multiple Arrows"
                className="arrows-img"
                style={{
                    width: '80px',
                    height: '40px',
                    maxWidth: '100%',
                    objectFit: 'contain',
                    flexShrink: 0,
                }}
            />
            {/* Responsive styles */}
            <style>
                {`
                @media (max-width: 700px) {
                    .app-header-responsive {
                        flex-direction: column !important;
                        align-items: flex-start !important;
                        min-height: 120px !important;
                        padding: 8px !important;
                        gap: 6px !important;
                    }
                        .header-logo {
                            margin-left: auto !important;
                            margin-right: auto !important;
                            display: block !important;
                        }
                    .app-header-responsive > img {
                        width: 60px !important;
                        height: 40px !important;
                    }
                    .app-header-responsive > div {
                        flex-direction: column !important;
                        align-items: flex-start !important;
                        gap: 4px !important;
                        width: 100% !important;
                    }
                    .app-header-responsive h1 {
                        font-size: 15px !important;
                        white-space: normal !important;
                        text-align: center !important; /* <-- Add this line */
                        width: 100% !important;        /* <-- Add this line */
                    }
                    .app-header-responsive h2 {
                        font-size: 12px !important;
                        white-space: normal !important;
                    }
                    .app-header-responsive span.header-separator,
                    .app-header-responsive .header-subtitle {
                        display: none !important;
                    }
                        .arrows-img {
                        display: none !important;
                    }
                }
                `}
            </style>
        </Header>
    );
};

export default AppHeaderTemplate2;
